var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinEmpresarialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "332.000000pt",
    height: "425.000000pt",
    viewBox: "0 0 332.000000 425.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,425.000000) scale(0.100000,-0.100000)",
    fill: "#8d59a4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1580 4085 l0 -155 -325 0 -325 0 0 -220 0 -220 -310 0 -310 0 -2 -1657 -3 -1658 -152 -3 -153 -3 0 -79 0 -80 1655 0 1655 0 0 80 0 80 -150 0 -150 0 0 1660 0 1660 -315 0 -315 0 0 220 0 220 -320 0 -320 0 0 155 0 155 -80 0 -80 0 0 -155z m-2 -457 l3 -138 -246 0 -245 0 0 133 c0 74 3 137 7 141 4 3 113 5 242 4 l236 -3 3 -137z m642 2 l0 -140 -240 0 -240 0 0 140 0 140 240 0 240 0 0 -140z m-642 -1597 l-3 -1288 -347 -3 -348 -2 0 -285 0 -285 -205 0 -205 0 0 1575 0 1575 555 0 555 0 -2 -1287z m1270 -285 l-3 -1573 -207 -3 -208 -2 0 285 0 285 -345 0 -345 0 0 105 0 105 345 0 345 0 0 80 0 80 -345 0 -345 0 0 160 0 160 345 0 345 0 0 85 0 85 -345 0 -345 0 0 160 0 160 345 0 345 0 0 80 0 80 -345 0 -345 0 0 165 0 165 345 0 345 0 0 80 0 80 -345 0 -345 0 0 165 0 165 345 0 345 0 0 80 0 80 -345 0 -345 0 0 130 0 130 555 0 555 0 -2 -1572z m-1273 -1368 l0 -195 -262 -3 -263 -2 0 200 0 200 263 -2 262 -3 0 -195z m695 0 l0 -200 -265 0 -265 0 0 200 0 200 265 0 265 0 0 -200z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinEmpresarialIcon);
export default __webpack_public_path__ + "static/media/zeppelin-empresarial-icon.ce9bd360.svg";
export { ForwardRef as ReactComponent };